import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import styles from "./patientexpensereport.module.css";
import basestyles from "../../../shared/styles/basestyles.module.css";
import Input from "../../../shared/components/Input/Input";
import Textarea from "../../../shared/components/Textarea/Textarea";
import Button from "../../../shared/components/Button/Button";
import Header from "../../../shared/components/Header/Header";
import Backicon from "../../../shared/components/Backicon/Backicon";

const reportintialState = {
  Name: "",
  Phone: "",
  Diagnose: "",
  Treatmentcost: "",
  NameError: "",
  PhoneError: "",
  DiagnoseError: "",
  TreatmentcostError: "",
};

class PatientExpenseReport extends React.Component {
  state = reportintialState;

  change = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  validate = () => {
    let NameError = "";
    let PhoneError = "";
    let DiagnoseError = "";
    let TreatmentcostError = "";

    if (!this.state.Name) {
      NameError = "Name cannot be empty";
    }
    if (!this.state.Phone) {
      PhoneError = "Phone number cannot be empty";
    }
    if (!this.state.Diagnose) {
      DiagnoseError = "This feild cannot be empty";
    }
    if (!this.state.Treatmentcost) {
      TreatmentcostError = "This feild cannot be empty";
    }
    if (NameError || PhoneError || DiagnoseError || TreatmentcostError) {
      this.setState({
        NameError,
        PhoneError,
        DiagnoseError,
        TreatmentcostError,
      });

      return false;
    }
    return true;
  };

  onSubmit = (e) => {
    e.preventDefault();
    const isvalid = this.validate();
    if (isvalid) {
      toast.info("Uploading Report...!", {
        autoClose: 2000,
      });
      const expense_report = {
        Name: this.state.Name,
        Phone: this.state.Phone,
        Diagnose: this.state.Diagnose,
        Treatmentcost: this.state.Treatmentcost,
      };
      localStorage.setItem(
        "expense_report_info",
        JSON.stringify(expense_report)
      );
      console.log(this.state);
      this.setState(reportintialState);
    }
  };

  render() {
    return (
      <>
        <div className={styles.backgroundpic}>
          <Header name="Expense Report" />
          <Backicon
            onClick={() => this.props.history.goBack()}
            style={{
              background:
                "linear-gradient(60deg, rgba(2, 12, 29, 0.644) 0%, rgba(67, 184, 192, 0.548) 98%)",
              color: "white",
            }}
          />
          <div className={basestyles.inputWidth}>
            <form>
              <label className={styles.hrName}>Name</label>
              <Input
                placeholder="Name"
                type="text"
                value={this.state.Name}
                name="Name"
                onChange={(e) => this.change(e)}
              />
              <div className={styles.error}>{this.state.NameError}</div>

              <label className={styles.hrphone}>Phone</label>
              <Input
                type="tel"
                placeholder="1-555-777-6666"
                value={this.state.Phone}
                name="Phone"
                onChange={(e) => this.change(e)}
              />
              <div className={styles.error}>{this.state.PhoneError}</div>

              <label className={styles.hrprob}>Diagnose</label>
              <Textarea
                placeholder="Accident, Flu, Injuries, Colds, Allergies, and  Headaches..etc"
                value={this.state.Diagnose}
                name="Diagnose"
                onChange={(e) => this.change(e)}
              />
              <div className={styles.error}>{this.state.DiagnoseError}</div>

              <label className={styles.hradvise}>Treatment Cost</label>
              <Input
                type="text"
                placeholder="$"
                value={this.state.Treatmentcost}
                name="Treatmentcost"
                onChange={(e) => this.change(e)}
              />
              <div className={styles.error}>
                {this.state.TreatmentcostError}
              </div>

              <Button
                onClick={(e) => this.onSubmit(e)}
                buttonName="Submit"
                style={{
                  color: "white",
                  margin: "30px 15px 30px",
                  padding: "10px 10px",
                  width: "90%",
                  maxWidth: "500px",
                }}
              >
                Submit
              </Button>
            </form>
            <ToastContainer />
          </div>
        </div>
      </>
    );
  }
}

export default PatientExpenseReport;
